import React from 'react';
import { useLocaleContext } from '../../../../../context/LocaleContext';
import { useScheduleContext } from '../../../../../context/ScheduleContext';
import { hexToRgba } from '../../../../../helpers/hexToRgb';
import { unixFormat } from '../../../../../helpers/times';

import './style.scss';

const ScheduleBreakCard = ({episode, isGridView = false, showTime = true, className = '', cardStyles = {}, attributes = {}}) => {
    const $locale = useLocaleContext();
    const {isWidget} = useScheduleContext();

    let cardBackground = !!episode.color
        ? hexToRgba(episode.color, episode.delayOpacity ?? 80)
        : `rgba(var(--app-color-light-rgb),${episode.delayOpacity !== null && episode.delayOpacity >= 0 ? episode.delayOpacity / 100 : 0.8})`;

    if (isWidget) {
        cardBackground = `rgba(var(--app-delayBackgroundColor),${episode.delayOpacity !== null && episode.delayOpacity >= 0 ? episode.delayOpacity / 100 : 0.8})`;
    }

    return (
        <div
            className={`schedule-card-break background-blur ${isGridView ? 'schedule-card-break--grid' : ''} ${episode.importantEpisode ? 'schedule-card-break--important' : ''} ${className}`}
            style={{
                ...cardStyles,
                backgroundColor: cardBackground,
                backdropFilter: !!episode.delayBlur ? `blur(${episode.delayBlur}px)` : '',
            }}
            {...attributes}
        >
            <div className="schedule-card-break__info">
                {
                    (!!episode.displayTime && showTime) &&
                    <p className={`schedule-card-break__info-time ${episode.displayTimeLarge ? 'schedule-card-break__info-time--lg' : ''}`}>
                        {unixFormat(episode.timeStart, 'HH:mm')} — {unixFormat(episode.timeStop, 'HH:mm')}
                    </p>
                }
                <h2 className={`schedule-card-break__info-title ${episode.displayNameLarge ? 'schedule-card-break__info-title--lg' : ''}`}>
                    {$locale.getProperty(episode, 'name')}
                </h2>
                <p className="schedule-card-break__info-description">
                    {$locale.getProperty(episode, 'info')}
                </p>
            </div>
            <div className="schedule-card-break__partners">

            </div>
        </div>
    )
};

export default ScheduleBreakCard;
